import { createContext, useContext, useReducer, useCallback } from 'react';

const initialFilterState = {
  platforms: { value: [], exclude: false },
  countries: { value: [], exclude: false },
  affiliations: { value: [], exclude: false },
  bots: { value: null, exclude: false },
  discreditations: { value: [], exclude: false },
  audience: { value: [0, 1000000000], exclude: false },
  geoGroup: { value: [], exclude: false },
};

const initialState = {
  draftFilters: { ...initialFilterState },
  filters: { ...initialFilterState },
};

const filterReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_DRAFT_FILTERS':
      return {
        ...state,
        draftFilters: { ...state.draftFilters, ...action.payload },
      };
    case 'APPLY_DRAFT_FILTERS':
      return {
        ...state,
        filters: { ...state.draftFilters },
      };
    case 'RESET_DRAFT_FILTERS':
      return {
        ...state,
        draftFilters: { ...initialFilterState },
      };
    default:
      return state;
  }
};

const BreakdownsFilterContext = createContext(undefined);

export const BreakdownsFilterProvider = ({ children, isShare = false }) => {
  const [state, dispatch] = useReducer(filterReducer, initialState);

  const updateDraftFilters = useCallback((filters) => {
    dispatch({ type: 'UPDATE_DRAFT_FILTERS', payload: filters });
  }, []);

  const applyDraftFilters = useCallback(() => {
    dispatch({ type: 'APPLY_DRAFT_FILTERS' });
  }, []);

  const resetDraftFilters = useCallback(() => {
    dispatch({ type: 'RESET_DRAFT_FILTERS' });
  }, []);

  const value = {
    state,
    isShare,
    updateDraftFilters,
    applyDraftFilters,
    resetDraftFilters,
  };

  return (
    <BreakdownsFilterContext.Provider value={value}>
      {children}
    </BreakdownsFilterContext.Provider>
  );
};

export const useBreakdownsFilterContext = () => {
  const context = useContext(BreakdownsFilterContext);
  if (context === undefined) {
    throw new Error('useBreakdownsFilterContext must be used within a BreakdownsFilterProvider');
  }
  return context;
};

export const getEmptyBreakdownsFilterState = () => ({ ...initialFilterState });
